import {User} from "../../shared/models/user.model";

export const initialState: AuthState = {
  token: null,
  isAuthenticated: false,
  loading: false,
  user: null,
  error: '',
}

export interface AuthState {
  token: string | null,
  isAuthenticated: boolean,
  loading: boolean,
  user: User | null,
  error: any;
}

